/* eslint-disable no-undef */
import React, { useState } from 'react';
import Sidebar from '../../Components/Sidebar/Sidebar';
import Footer from '../../Components/Footer/Footer';
import PropTypes from 'prop-types';
import './FacilityFrontPage.css';
import {
  Box,
  Button,
  ImageList,
  ImageListItem,
  Modal,
  Typography,
  styled,
} from '@mui/material';
import { uploadImagesAndSaveRecords } from './uploadForm';
import { HelmetProvider } from 'react-helmet-async';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  padding: 4,
};

function FacilityFrontPage({ facilityName, facilityLogo, facilityId }) {
  const [yourName, setYourName] = useState('');
  const [residentName, setResidentName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [comment, setComment] = useState('');
  const [images, setImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleImageChange = (e) => {
    setImages([...e.target.files]);
  };

  const handleConfirmSubmission = async () => {
    await uploadImagesAndSaveRecords(
      {
        uploader: yourName,
        residentName,
        email,
        phone,
        comment,
      },
      images,
      facilityId,
    );

    setIsModalOpen(false);

    setYourName('');
    setResidentName('');
    setEmail('');
    setPhone('');
    setComment('');
    setImages([]);
  };

  return (
    <div>
      <HelmetProvider>
        <title>{facilityName} - Image Submission System - FHS</title>
        <meta
          name="twitter:title"
          content={`${facilityName} - Image Submission System - FHS`}
        />
        <meta
          property="og:title"
          content={`${facilityName} - Image Submission System - FHS`}
        />

        <meta
          name="description"
          content={`Image Submission System for ${facilityName} - Foundations Health Solutions`}
        />
        <meta
          property="og:description"
          content={`Image Submission System for ${facilityName} - Foundations Health Solutions`}
        />
        <meta
          name="twitter:description"
          content={`Image Submission System for ${facilityName} - Foundations Health Solutions`}
        />
      </HelmetProvider>
      <div className="pageWithSidebar">
        <div className="mainContent">
          <div className="facilityLogoContainer">
            {facilityLogo && (
              <img
                src={require(`../../assets/facility-logos/${facilityLogo}`)}
                className="facilityLogo"
                alt="Facility logo"
              />
            )}
          </div>
          <h1 className="WelcomeTitle">Welcome to</h1>
          <h1>{facilityName}</h1>

          {/* <p>
            This page provides a secure form to send your images to our staff.
          </p>
          <p>Fill the form below and upload the images from your device.</p>

          <form
            className="imageForm"
            name="contact"
            onSubmit={handleFormSubmit}
          >
            <h2>Image Upload</h2>

            <hr />
            <input
              type="text"
              name="Your-Name"
              placeholder="Your Name"
              value={yourName}
              onChange={(e) => setYourName(e.target.value)}
              required
            />

            <input
              type="text"
              name="Resident-Name"
              placeholder="Resident Name"
              value={residentName}
              onChange={(e) => setResidentName(e.target.value)}
              required
            />

            <input
              type="email"
              name="Email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
            />

            <input
              type="tel"
              name="Phone"
              placeholder="Phone (Optional)"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />

            <input
              type="text"
              name="Comment"
              placeholder="Comment (Optional)"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <div className="imageuploadbuttonContainer">
              <Button
                className="fileUpload"
                component="label"
                variant="contained"
                id="imageUploadButton"
                tabIndex={-1}
                startIcon={<ImageIcon />}
              >
                Select Pictures
                <VisuallyHiddenInput
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={handleImageChange} // Use the updated handler here
                  required
                  multiple
                />
              </Button>
            </div>
            <hr />
            <Button
              type="submit"
              component="button"
              variant="contained"
              id="sendButton"
              endIcon={<SendIcon />}
            >
              Send
            </Button>
          </form> */}
        </div>
        <Sidebar isHomePage={true} facilityId={facilityId} />
      </div>
      <Footer />

      <Modal
        open={isModalOpen}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Review your images before submission
          </Typography>
          {/* <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Review your images before submission.
          </Typography> */}
          {/* Scrollable image container */}
          <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <ImageList variant="masonry" cols={3}>
              {images &&
                Array.from(images).map((file, index) => (
                  <ImageListItem key={index}>
                    <img
                      src={`${URL.createObjectURL(file)}#`}
                      srcSet={`${URL.createObjectURL(file)}#`}
                      alt={`preview ${index}`}
                      loading="lazy"
                      style={{ width: '100%', height: '100%' }}
                    />
                  </ImageListItem>
                ))}
            </ImageList>
          </Box>
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Button color="error" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button variant="contained" onClick={handleConfirmSubmission}>
              Confirm Upload
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

FacilityFrontPage.propTypes = {
  facilityName: PropTypes.string.isRequired,
  facilityLogo: PropTypes.string,
  facilityId: PropTypes.string,
};

export default FacilityFrontPage;
